export default __webpack_public_path__ + "static/media/title-cover.7914cdd4.png";